import { render } from "./PaginationBlock.vue?vue&type=template&id=0daf8952"
import script from "./PaginationBlock.vue?vue&type=script&lang=js"
export * from "./PaginationBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__